import { useI18n } from '../i18n';
import LanguageSelect from './LanguageSelect';

export default function Header() {
  const { t, lang } = useI18n();

  const links = [
    { href: '#services', label: t('nav.services') },
    { href: '#about', label: t('nav.about') },
    { href: '#tech', label: t('nav.tech') },
    { href: '#contact', label: t('nav.contact') },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-[#FDE68A]/50 bg-[#FFFBEB]/90 backdrop-blur-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <a href="#" className="font-['Russo_One'] text-2xl uppercase tracking-tight text-[#78350F]">
          Amber<span className="text-[#F59E0B]">Bytes</span>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-semibold uppercase tracking-wider text-[#78350F] transition-colors hover:text-[#F59E0B]"
            >
              {link.label}
            </a>
          ))}
          <LanguageSelect label={t('footer.language')} />
        </nav>
        <div className="md:hidden">
          <LanguageSelect label={t('footer.language')} />
        </div>
      </div>
    </header>
  );
}
